import { centerDynamicModalConfig } from '../../shared/helpers/modal.config';
import { AddStudentComponent } from './add-student/add-student.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { eModalRoles } from '../../shared/models/modals';
import { Component, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { InviteStudentComponent } from './invite-student/invite-student.component';
import { canAdministerStudents } from '../../shared/helpers/osk-staff-role';

@Component({
  selector: 'app-students',
  templateUrl: './students.component.html',
  styleUrl: './students.component.scss',
})
export class StudentsComponent {
  private _primengDialogService = inject(DialogService);

  public activeIndex: number = 0;
  public loading: boolean = false;
  public resetTable = new Subject<void>();
  /** Instructors and lecturers only see their students; adding them is for the boss and the office. */
  public readonly canAdministerStudents = canAdministerStudents();

  private ref: DynamicDialogRef | undefined;

  addNewStudent(): void {
    this.openNewStudentModal();
  }

  showInviteModal(): void {
    this.ref = this._primengDialogService.open(InviteStudentComponent, {
      ...centerDynamicModalConfig,
      width: '966px',
    })
  }
  private openNewStudentModal() {
    this.ref = this._primengDialogService.open(AddStudentComponent, {
      ...centerDynamicModalConfig,
      width: '966px',
    });

    this.ref.onClose.subscribe((res) => {
      if (res === eModalRoles.SUCCESS) {
          this.resetTable.next();
      }
      console.log('Modale with add new user closed with status:', res);
    });
  }
}
